// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tSRw","field":"styles_field__1FGN_","fieldCol":"styles_fieldCol__26fAy","diffCol":"styles_diffCol__1x53F","diff":"styles_diff__3zSs6"};